import { NgTemplateOutlet } from '@angular/common';
import { AfterContentInit, Component, ElementRef, HostBinding, Input, OnChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { ThemeService } from './../../../../services/theme/theme.service';

@Component({
  selector: 'app-text-button',
  templateUrl: './text-button.component.html',
  styleUrls: ['./text-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, NgTemplateOutlet, RouterLink],
})
export class TextButtonComponent implements OnChanges, AfterContentInit {
  private themeService = inject(ThemeService);
  private elRef = inject(ElementRef);

  @HostBinding('style.pointer-events') pointerEvents: 'none' | 'auto';

  @HostBinding('tabindex') tabindex = -1;
  @Input() tabIndex: number;
  @Input() disabled = false;
  @Input() type = 'submit';
  @Input() target = '_self';
  @Input() color: ThemePalette = 'primary';
  @Input() href: string;
  @Input() routerLink: string;

  isLink: boolean;

  ngOnChanges() {
    this.isLink = !!this.href || !!this.routerLink;
    this.pointerEvents = this.disabled ? 'none' : 'auto';
  }

  ngAfterContentInit() {
    this.themeService.subscribeComponent(this.elRef);
  }
}
